import roundPresentationValues from 'helpers/presentation/roundPresentationValues'
import fovModeHelper from 'helpers/fovModeHelper'
import consolidatePresentationKey from 'helpers/presentation/consolidatePresentationKey'

export default function calculatePresentationValues({ camera, key, value, prevPresentationValues, fromMap, skipRoundFocal }) {
  const updatedCamera = Object.assign({}, camera, {
    angleOfView: camera[`${fovModeHelper(camera.fovMode)}AngleOfView`],
    fieldOfView: camera[`${fovModeHelper(camera.fovMode)}FieldOfView`]
  })

  return roundPresentationValues({ camera: updatedCamera, key: consolidatePresentationKey(key), value, prevPresentationValues, fromMap, skipRoundFocal })
}



// WEBPACK FOOTER //
// ./src/helpers/presentation/calculatePresentationValues.js